import { render } from "./Issues.vue?vue&type=template&id=3b968738&scoped=true"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"

import "./Issues.vue?vue&type=style&index=0&id=3b968738&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b968738"]])

export default __exports__